import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { FaStar } from 'react-icons/fa'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useRef, useState } from 'react'
import { RequestProvider } from '../../../context/RequestContext'
import { Services } from '../../../components/index/service/Services'
import { AnimatePresence, motion } from 'framer-motion'
import { getWpNewHouseKeeping, setWpNewHouseKeeping } from '../../../service/wp-blogs-store'
import { getWpNewPostsByCategory } from '../../../lib/service'
import { PartTimeHelperBooking } from '../../../components/index/service-category/domestic-service/PartTimeHelperBooking'
import { getAppSettings } from '../../../api/app-setting/app-setting'
import { SystemError } from '../../../components/error/SystemError'
import { openModal } from '../../../service/modal-service'
import { HelperServiceScope } from '../../../components/index/service-category/domestic-service/HelperServiceScope'
import { ElderlyCareScope } from '../../../components/index/service-category/domestic-service/ElderlyCareScope'
import { helperCostCalculation } from '../../../js/part-time-helper-cost'
import { helperTestimonials } from '../../../data/CustomerReviewData'

export async function getStaticProps() {
    const countryCd = "sg"
    const countryName = "Singapore"
    
    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Domestic Services")
    
    const lat = 1.3521
    const lng = 103.8198

    const { modifiedDate, month, year } = getArticleDateTime()
    const houseKeepingBlogs = blogsMaster['house-keeping'].blogArray;
    const wpNewPosts = getWpNewHouseKeeping().length > 0 ?  getWpNewHouseKeeping() : await getWpNewPostsByCategory(6, "house-keeping");
    setWpNewHouseKeeping(wpNewPosts)
    
    const currencyCd = "SGD"

  let helperService = []
  let babySitterService = []
  let elderlyCareService = []
  let cookingAssistanceService = []  
  
  helperCostCalculation(currencyCd, helperService, babySitterService, elderlyCareService, cookingAssistanceService)

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        houseKeepingBlogs,
        wpNewPosts,
        currencyCd,
        helperService,
        elderlyCareService,
        helperTestimonials,
        countryName
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}
export default function Home(props) {
    const router = useRouter()
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const houseKeepingBlogs = props.houseKeepingBlogs
    const wpNewPosts = props.wpNewPosts
    const requestCategorySettings = props.requestCategorySettings;
    const testimonials = props.helperTestimonials
    const maxRating = [1, 2, 3, 4, 5]
    const requestType = 'Domestic Services'
    const countryName = props.countryName
    const currencyCd = props.currencyCd
    const helperService = props.helperService
    const elderlyCareService = props.elderlyCareService

    const [ requestForm, setRequestForm ] = useState(router.query.requestForm)
    const [ waInd, setWaInd ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const [ isShowJobScope, setIsShowJobScope ] = useState(false)

    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""})

    useEffect(() => {
        setRequestForm(router.query.requestForm)
    }, [router.query.requestForm])

    const videoRef = useRef();

    useEffect(() => {    
        if(requestForm) return
        videoRef.current.play()
    }, [requestForm])

    const fetchAppSetting = useCallback(async() => {
        try {
            const appSettings = await getAppSettings(countryName)
            setWaInd(appSettings.waBusinessInd)
        } catch (error) {
            console.log(error);
        }
    }, [countryName])

    useEffect(() => {
        if(!countryName) return

        fetchAppSetting()
    }, [countryName, fetchAppSetting])

    const showJobScope = () =>{
        setErrorContent({'header': "Service Inclusions", 'isInfo': true, 'body': "Kitchen Assistance - Dishwashing, countertop wiping, and organizing for a tidy kitchen.\n\nHousekeeping - Sweeping/vacuuming, mopping, dusting, sanitizing, toilet cleaning, indoor side of window cleaning and maintaining overall home cleanliness.\n\nBabysitting, nanny & elderly care service.\n\nNote: The helper will not be carrying any equipment.\nThis service is for residential premises only."});
        openModal(setIsSystemError)
    }

  return (
    <>
      <Head>
        <title>Part Time Elderly Care Service Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="StringsSG brings to you reliable and trustworthy helpers to take care of elderly in your family at an affordable pricing. Book now!"/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/part-time-cleaner-singapore/elderly-care" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Part Time Elderly Care Service Singapore`}/>
        <meta property="og:description" content="StringsSG brings to you reliable and trustworthy helpers to take care of elderly in your family at an affordable pricing. Book now!" />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-26T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/part-time-helper/babysitter-with-girl.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/part-time-helper/babysitter-with-girl.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/part-time-cleaner-singapore/elderly-care"/>
        <meta name="twitter:title" content={`Part Time Elderly Care Service Singapore`}/> 
        <meta name="twitter:description" content="StringsSG brings to you reliable and trustworthy helpers to take care of elderly in your family at an affordable pricing. Book now!"/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/part-time-cleaner-singapore/elderly-care"},"headline":"Part Time Elderly Care Service Singapore","description":"StringsSG brings to you reliable and trustworthy helpers to take care of elderly in your family at an affordable pricing. Book now!","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/part-time-helper/babysitter-with-girl.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-26T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"part-time-helper","item":"https://www.stringssg.com/sg/part-time-cleaner-singapore"},{"@type":"ListItem","position":2,"name":"elderly-care"}]}]}`
          }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/part-time-cleaner-singapore/elderly-care"/>
        </Head>
        <section id="helper-job-scope-singapore" className='relative'>
            <div className="-mt-14 relative w-full aspect-video sm:h-180 overflow-hidden">
                {/* Mobile Video */}
                <video
                    ref={videoRef}
                    className="absolute inset-0 w-full h-full object-cover sm:hidden"
                    poster={s3Static + "blog/living/part-time-helper/elderly-cares-maid-1920-1080.jpg"}
                    title="Part-time elderly care in Singapore"
                    muted
                    loop
                    playsInline
                    preload="metadata"
                >
                    <source src="/video/part-time-helper-web.mp4" />
                    <source src="/video/part-time-helper-web.mov" />
                </video>

                {/* Desktop Image */}
                <Image
                    src={s3Static + "blog/living/part-time-helper/elderly-cares-maid.jpg"}
                    fill
                    className="hidden sm:block object-cover"
                    alt="Part-time elderly care in Singapore"
                    priority={false}
                    quality={100}
                    sizes="100vw"
                />
            </div>
            <RequestProvider>
                <div id="campaign" className='relative bg-gray-100 sm:bg-transparent sm:text-white w-full py-2 sm:absolute sm:top-1/2 sm:-translate-y-1/2'>
                    <PartTimeHelperBooking requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} helperService={helperService} elderlyCareService={elderlyCareService}
                        setIsQuickBook={setIsQuickBook} countryName={countryName} currencyCd={currencyCd} helperType="Elderly Care" showJobScope={setIsShowJobScope}/>
                </div>
                {requestForm &&
                    <Services requestType={requestType} requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} isQuickBook={isQuickBook} asSheet/>
                }      
            </RequestProvider>  
        </section>
        <div className='max-w-4xl mx-auto py-10 px-2 space-y-8'>
            <div className='space-y-2 text-center '>
                <h1 className='text-3xl md:text-4xl font-semibold'>
                    Part Time Elderly Care Service Singapore
                </h1>
                {/* <div className='text-gray-400 text-xs'>
                    <time dateTime={modifiedDate}>Updated - {new Date(modifiedDate).toUTCString().substring(0,16)}</time>
                </div>                     */}
            </div>
            <div className='leading-8 space-y-3'>
                <p>
                    StringsSG brings to you reliable and trustworthy helpers to take care of elderly in your family at an affordable pricing.
                </p>
                <p>                        
                    At StringsSG, we recognize the importance of compassionate and reliable elderly care. Our part-time elderly care 
                    services are designed to provide dedicated support and companionship for your loved ones while accommodating their 
                    specific needs.                        
                </p>
            </div>                
        </div>
        <div className='max-w-4xl mx-auto py-10'>
            <h2 className='text-xl md:text-2xl text-center uppercase'>
                <strong>Important Aspects of Part-time Elderly Care</strong>
            </h2>
            <div className='mt-10 text-sm leading-7 space-y-5'>      
                <div className='bg-slate-200 px-2 py-5 text-center h-full'>
                    <h3 className='text-base'><strong>1. Companionship and Social Interaction</strong></h3>
                    <p className='py-5 max-w-3xl mx-auto'>
                        Our caregivers provide companionship and engage in meaningful interactions, fostering a positive and stimulating environment for your loved ones.
                    </p> 
                </div>
                <div className='px-2 py-5 text-center h-full'>
                    <h3 className='text-base'><strong>2. Assistance with Daily Activities</strong></h3>
                    <div className='py-5 max-w-3xl mx-auto'>
                        From meal preparation and medication reminders to light housekeeping, our caregivers assist with daily tasks, promoting independence while ensuring safety.
                    </div> 
                </div>
                <div className='bg-slate-200 px-2 py-5 text-center h-full'>
                    <h3 className='text-base'><strong>3. Personalized Attention</strong></h3>
                    <p className='py-5 max-w-3xl mx-auto'>
                        Each elderly individual has unique needs. We personalize our care to address specific requirements, ensuring comfort and well-being.
                    </p> 
                </div>
            </div>
        </div> 
        <div className='h-120 py-8 relative bg-black'>
            <h2 className='text-2xl md:text-3xl text-center px-2 uppercase text-white absolute left-0 right-0 z-10 top-10'>
                <strong>Why us?</strong>
            </h2>
            <Image className='opacity-40'
                src={s3Static + "blog/living/part-time-helper/indonesian-maid.jpg"}
                fill
                style={{objectFit: 'cover', objectPosition: 'center'}}   
                placeholder='blur'
                blurDataURL={s3Static + "placeholder.png"}
                alt='Affordable Part Time Helper Service - StringsSG'
            /> 
            <div className='text-white py-20 leading-8'>
                <Carousel autoPlay={true} infiniteLoop={true} showThumbs={false} showStatus={false} interval={5000} preventMovementUntilSwipeScrollTolerance={true} swipeScrollTolerance={50}>
                    <div className='px-6 py-10 h-full'>
                        <h3 className='text-xl'><strong>Instant Booking</strong></h3>
                        <p className='py-5 max-w-3xl mx-auto'>
                            Our platform allows for instant booking, providing immediate access to a pool of vetted and skilled caregivers.
                        </p> 
                    </div>
                    <div className='px-6 py-10 h-full'>
                        <h3 className='text-xl'><strong>Best Helper Service Quality</strong></h3>
                        <div className='py-5 max-w-3xl mx-auto'>
                            We have onboarded highly ethical and diligent team of part-time helpers on our platform, and have standardized the service quality.
                        </div> 
                    </div>
                    <div className='px-6 py-10 h-full'>
                        <h3 className='text-xl'><strong>Affordable</strong></h3>
                        <p className='py-5 max-w-3xl mx-auto'>
                            Our platform provides you with the best pricing based on a dynamic cost calculation algorithm for your requirements.
                        </p> 
                    </div>
                    <div className='px-6 py-10 h-full'>
                        <h3 className='text-xl'><strong>Customer Service</strong></h3>
                        <p className='py-5 max-w-3xl mx-auto'>
                            Use the live chat feature on the app to initiate conversation with the assigned service team.
                        </p> 
                    </div>
                </Carousel>      
            </div>
        </div>
        <div className='max-w-4xl mx-auto py-10 px-2 text-sm'>
            <h2 className='text-xl md:text-2xl text-center uppercase py-5'>
                <strong>5 Benefits of Hiring an Elderly Caregiver</strong>
            </h2>
            <div className='py-4 grid grid-cols-1 md:grid-cols-2 gap-2'>
                <div className='relative w-full h-96'>
                    <Image
                        src={s3Static + "blog/living/part-time-helper/helper-with-elderly-lady.jpg"}
                        fill
                        style={{objectFit: 'cover'}}
                        alt='Helper with elderly lady'
                        placeholder="blur"
                        blurDataURL={s3Static + "placeholder.png"}
                    />
                </div>
                <div className='flex items-center'>
                    <div className='space-y-2 leading-7'>
                        <div>
                            <h3><strong>1. Companionship and Emotional Support</strong></h3>
                            <p>
                            Elderly caregivers provide companionship and emotional support, reducing feelings of loneliness and 
                            isolation commonly experienced by seniors. Their presence fosters a positive and reassuring environment.
                            </p>
                        </div>
                        <div>
                            <h3><strong>2. Personalized Care and Assistance</strong></h3>
                            <p>
                            Caregivers tailor their care to the individual needs of seniors. They assist with daily activities, 
                            medication reminders, and mobility support, ensuring a higher quality of life and maintaining independence.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='py-4 grid grid-cols-1 md:grid-cols-2 md:space-x-2 space-y-2'>
                <div className='relative w-full h-96 md:hidden'>
                    <Image
                        src={s3Static + "blog/living/part-time-helper/elderly-care-helper.jpg"}
                        fill
                        style={{objectFit: 'cover'}}
                        alt='Elderly care helper'
                        placeholder="blur"
                        blurDataURL={s3Static + "placeholder.png"}
                    />
                </div>
                <div className='flex items-center'>
                    <div className='space-y-2 leading-7'>
                        <div>
                            <h3><strong>3. Ensuring Safety and Well-being</strong></h3>
                            <p>
                            Caregivers prioritize the safety and well-being of seniors, offering supervision, fall prevention measures, 
                            and immediate assistance in case of emergencies, providing peace of mind for both seniors and their families.
                            </p>
                        </div>
                        <div>
                            <h3><strong>4. Social Engagement and Mental Stimulation</strong></h3>
                            <p>
                            Engaging activities and conversations provided by caregivers promote mental stimulation and social interaction, 
                            contributing to cognitive health and overall well-being for seniors.
                            </p>
                        </div>
                    </div>
                </div>
                <div className='relative w-full h-96 hidden md:flex'>
                    <Image
                        src={s3Static + "blog/living/part-time-helper/elderly-care-helper.jpg"}
                        fill
                        style={{objectFit: 'cover'}}
                        alt='Elderly care helper'
                        placeholder="blur"
                        blurDataURL={s3Static + "placeholder.png"}
                    />
                </div>
            </div>
            <div className='space-y-2 leading-7'>
                <h3><strong>5. Relief for Family Members</strong></h3>
                <p>
                    Hiring a caregiver allows family members to focus on their daily commitments, knowing that their loved one is 
                    receiving dedicated care. It alleviates the stress and burden of providing constant care while maintaining a 
                    professional standard of support.
                </p>
            </div>
        </div>          
        <div className='max-w-4xl mx-auto py-10 space-y-5 px-4 leading-7 text-sm'>
            <h2 className='text-xl md:text-2xl text-center uppercase'>
                <strong>Hourly Rates Of Elderly Caregiver In Singapore</strong>
            </h2>
            <p className='pt-5'>
                Elderly Caregivers in Singapore can cost anywhere between in $20 to $30 per hour.
            </p>
            <p>
                The caregiver&apos;s experience, qualifications, and specialized training impact rates, with experts or certified 
                caregivers often charging higher fees. The range of services provided, including personal care or specialized 
                therapies, also influences rates. Market demand and location, varying between urban and suburban areas, contribute to 
                rate differences due to living expenses and local demand. 
            </p>
            <p>
                Caregivers create personalized plans based on specific needs, 
                potentially affecting pricing. Discounts for longer-term commitments or more extensive care blocks might be 
                offered, depending on the frequency and duration of care needed.
            </p>
            <p>
                Transparent pricing structures and clear 
                communication are upheld by reputable caregivers to ensure families understand rates and any additional fees upfront. 
                Rates may further vary based on individual requirements, allowing caregivers to adjust pricing for specialized medical 
                needs or additional services.
            </p>
        </div>
        <div className='max-w-5xl mx-auto text-center py-10 relative'>
            <div className='relative w-full h-96'>
                <Image
                    src={s3Static + "blog/living/part-time-helper/maid-with-old-lady.jpg"}
                    fill
                    style={{objectFit: 'cover', objectPosition: ''}} 
                    placeholder='blur'
                    blurDataURL={s3Static + "placeholder.png"}
                    alt='Hire helper for elderly care - StringsSG'
                />     
            </div> 
            <div className='absolute flex items-center text-white top-0 bottom-0 left-0 right-0 w-fit mx-auto rounded-3xl'>
                <Link href="/sg/part-time-cleaner-singapore" prefetch={false} className='p-4 rounded-lg bg-black/60 text-xl md:text-2xl0'>
                        Hire Elderly Care Helper
                </Link>       
            </div>  
        </div>  
        <BlogsList blogs={houseKeepingBlogs} wpPosts={[]} wpNewPosts={wpNewPosts}/>
        {isShowJobScope &&
            <AnimatePresence>
                <ElderlyCareScope/>
            </AnimatePresence>
        } 
        <AnimatePresence>
            {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
        </AnimatePresence>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}